import type { Freshness, PriceKind } from './types'

/** Default maximum age before fiat reference rates are flagged as stale. */
export const DEFAULT_MAX_AGE_MS = 36 * 60 * 60 * 1000

/**
 * Date-only (daily central-bank) rates are not published on weekends or holidays,
 * so they are only flagged after 4 days.
 */
export const DAILY_MAX_AGE_MS = 4 * 24 * 60 * 60 * 1000

export function maxAgeFor(precision: 'day' | 'time' | undefined): number {
  return precision === 'day' ? DAILY_MAX_AGE_MS : DEFAULT_MAX_AGE_MS
}

export function getFreshness(
  kind: PriceKind,
  asOf: string,
  now: Date = new Date(),
  maxAgeMs: number = DEFAULT_MAX_AGE_MS,
): Freshness {
  if (kind === 'demo') return 'demo'
  const ts = Date.parse(asOf)
  if (Number.isNaN(ts)) return 'stale'
  return now.getTime() - ts > maxAgeMs ? 'stale' : 'fresh'
}
